module.exports = __webpack_public_path__ + "static/media/Zoom_In@2x.07c1d4d0.png";